var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.orientState),expression:"orientState"}],attrs:{"id":"orientLayer"}},[_c('div',{staticClass:"phone"}),_c('span',{staticClass:"text"},[_vm._v("请旋转屏幕，竖屏观看")])])}
var staticRenderFns = []

export { render, staticRenderFns }